const addSomewMenItemu = [
  // {
  //   createAccount: "1",
  //   createTime: "2020.08.31 09:29:51",
  //   icon: "PieChartOutlined",
  //   id: "18000",
  //   modifyAccount: null,
  //   modifyTime: null,
  //   sort: 1,
  //   status: 1,
  //   title: "本地测试",
  //   uri: null,
  //   childList: [
  //     {
  //       childList: null,
  //       id: "0006200100", // 要根据这个跟本地的路由匹配，这个不能乱写
  //       title: "设备列表",
  //     },
  //     {
  //       childList: null,
  //       id: "0006200400", // 要根据这个跟本地的路由匹配，这个不能乱写 设备操作日志
  //       title: "设备操作日志",
  //     },
  //     {
  //       childList: null,
  //       id: "0006200300", // 要根据这个跟本地的路由匹配，这个不能乱写 设备操作日志
  //       title: "任务管理",
  //     },
  //     // {
  //     //   childList: null,
  //     //   id: "10zdbg", // 要根据这个跟本地的路由匹配，这个不能乱写
  //     //   title: "诊断报告",
  //     // },
  //   ],
  // },
];

export default addSomewMenItemu;



// WEBPACK FOOTER //
// ./src/AntD/components/display/menu/mock.js